import { apiUrl } from "utils/urls";

import axios from "axios";

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers["Authorization"] = `Token ${token}`;
    } else {
        delete config.headers["Authorization"];
    }
    return config;
});

export const loginApi = async (body) => {
    const { data } = await axios.post(apiUrl("login"), body);
    return data;
};

export const logout = async () => {
    const token = { auth_token: localStorage.getItem("token") };
    const { data } = await axios.post(apiUrl("logout"), token);
    return data;
};

export const signUpApi = async (body) => {
    const { data } = await axios.post(apiUrl("signup"), body);
    return data;
};

export const userCheck = async () => {
    const { data } = await axios.get(apiUrl("user") + "/check");
    return data;
};

export const adminChangeUser = async (body) => {
    const { data } = await axios.post(apiUrl("adminChangeUser"), body);
    return data;
};

export const getExitSurvey = async (body) => {
    const { data } = await axios.get(apiUrl("exitSurvey"));
    return data;
};

export const getUserProfile = async (params) => {
    const { data } = await axios.get(apiUrl("profile"), { params });
    return data;
};

export const patchUserProfile = async (body) => {
    //  body = Formdata
    // console.log(body);
    const { data } = await axios.patch(apiUrl("profile") + `/${body.id}`, body.formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

export const getProfileDisplayInfo = async (body) => {
    const { data } = await axios.post(apiUrl("profileDisplayInfo"), body);
    return data;
};
